import { gql } from "@apollo/client";

const userGroupType_fields = `
	UserGroupTypeId
	Name
	MembersMin
	MembersMax
	Created
	Updated
`;

export const GET_USER_GROUP_TYPES = gql(
  `query UserGroupType { userGroupTypes { ${userGroupType_fields} } }`
);
